import gql from "graphql-tag";

import type {ApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {checkUsernameType} from "./__graphql-types__/index.ts";

export const CHECK_USERNAME_QUERY: GqlOperation<
    checkUsernameType["response"],
    checkUsernameType["variables"]
> = gqlOp(gql`
    query checkUsername($username: String!) {
        checkUsername(username: $username) {
            error {
                code
            }
        }
    }
`);

export type CheckUsernameError =
    | "TOO_SHORT"
    | "BAD_CHARACTERS"
    | "UNAVAILABLE"
    | "INTERNAL";

export const checkUsernameQuery = (
    gqlClient: ApolloGqlClient,
    username: string,
) =>
    gqlClient.query(CHECK_USERNAME_QUERY, {
        variables: {username: username},
        fetchPolicy: "network-only",
    });
